import { Section, Eyebrow, Heading, P } from "../Chapter";
import { Reveal } from "../Reveal";
import { Stamp, MapPin, Shield, FileText, Feather, Asterisk } from "lucide-react";

const objects = [
    { icon: Stamp, term: "The stamp", line: "Asia's first adhesive postage stamp was issued in 1852 in Sindh: the Scinde Dawk, a small circular seal in red wax paper. Half an anna, and a country began to shrink." },
    { icon: MapPin, term: "The postmark", line: "A circle of ink recording the place and the date. The only proof of where a person stood in the world on a particular morning." },
    { icon: Shield, term: "The wax seal", line: "Not decoration. Evidence. Unbroken meant unread." },
    { icon: FileText, term: "The inland letter card", line: "A single blue sheet, folded into its own envelope, cheapest thing in the post office. You wrote until you ran out of paper, and then you stopped. Everyone's letters were the same length." },
    { icon: Feather, term: "The aerogramme", line: "Thin as a leaf so it weighed nothing on a plane. Held up to the light, you could almost read it from the outside." },
    { icon: Asterisk, term: "The postscript", line: "The thought that arrived after you thought you were finished. Often the truest line in the letter." },
];

export const Objects = () => (
    <Section>
        <Eyebrow>III. The objects</Eyebrow>
        <Heading>The things that came with a letter</Heading>
        <P>
            A letter was not only words. It was an object, and the object carried information the
            words didn't.
        </P>

        <div className="mx-auto mt-14 grid max-w-5xl grid-cols-1 gap-px overflow-hidden rounded-sm border border-rule bg-rule sm:grid-cols-2 lg:grid-cols-3">
            {objects.map((o, i) => {
                const Icon = o.icon;
                return (
                    <Reveal
                        key={o.term}
                        delay={(i % 3) * 0.08}
                        className="group flex flex-col gap-4 bg-paper p-8 transition-colors duration-500 hover:bg-surface"
                    >
                        <Icon size={22} strokeWidth={1.4} className="text-wax" />
                        <h3 className="font-serif text-2xl text-ink">{o.term}</h3>
                        <p className="font-serif text-[1.02rem] leading-relaxed text-sepia">{o.line}</p>
                    </Reveal>
                );
            })}
        </div>

        <P delay={0.1}>
            <span className="mt-14 block">
                None of this survives the transition. An email weighs nothing, comes from nowhere,
                and can be opened without leaving a mark.
            </span>
        </P>
    </Section>
);
